(function(){
  var el = document.getElementById('ptc-data');
  if(!el) return;
  var DATA; try { DATA = JSON.parse(el.textContent); } catch(e){ return; }
  if(!DATA.mods || !DATA.mods.length) return;

  var TURBO_PID = DATA.turbo.productId;
  var R = DATA.rules;
  var modal = document.getElementById('ptc-modal');
  if(!modal) return;

  var GROUPS = [
    {key:'intake',  label:'Intake'},
    {key:'cooling', label:'Cooling'},
    {key:'fueling', label:'Fueling'},
    {key:'exhaust', label:'Exhaust'},
    {key:'other',   label:'Other'}
  ];

  var selected = {};            // modProductId -> { variantId, price, name }
  var rendered = false;
  var turboPrice = DATA.turbo.price || 0;   // fallback; replaced by real cart price
  var turboDeposit = 0;                     // refundable core deposit (cents), excluded from discount

  function money(c){ return '$' + (c/100).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}); }
  function modPoints(p){ if(p < R.min) return 0; if(p > R.t3) return 3; if(p > R.t2) return 2; return 1; }
  // Refundable core deposit (DOLLARS) baked into a turbo variant, parsed from its
  // title — mirrors the discount function so the popup's projected saving matches
  // the cart exactly. Only the "refundable core deposit … ($NNN)" option matches;
  // real priced parts (inlet kits, DV/BOV, etc.) are left in the discount base.
  function coreDepositFromTitle(t){
    if(!t) return 0; var total = 0;
    t.split(' / ').forEach(function(seg){
      if(!/refundable core deposit/i.test(seg)) return;
      var ms = seg.match(/\(\s*\$\s*([\d,]+(?:\.\d+)?)\s*\)/g);
      if(!ms || !ms.length) return;
      var a = parseFloat(ms[ms.length-1].replace(/[^\d.]/g, ''));
      if(!isNaN(a)) total += a;
    });
    return total;
  }
  function availVariants(m){ return (m.variants||[]).filter(function(v){ return v.available; }); }
  function minPrice(m){ var vs = availVariants(m); if(!vs.length) return 0; return vs.reduce(function(a,v){ return Math.min(a, v.price); }, vs[0].price); }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function getCart(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); }
  function turboQty(cart){ var q=0; (cart.items||[]).forEach(function(i){ if(i.product_id===TURBO_PID) q += i.quantity; }); return q; }
  function turboUnitPrice(cart){ var p=0; (cart.items||[]).forEach(function(i){ if(i.product_id===TURBO_PID) p = i.price; }); return p; }
  function turboDepositCents(cart){ var d=0; (cart.items||[]).forEach(function(i){ if(i.product_id===TURBO_PID) d = Math.round(coreDepositFromTitle(i.variant_title) * 100); }); return d; }

  // ---------- render mod groups ----------
  function render_groups(){
    var wrap = document.getElementById('ptc-steps'); wrap.innerHTML = '';
    GROUPS.forEach(function(g){
      var mods = DATA.mods.filter(function(m){ return m.group === g.key && availVariants(m).length; });
      if(!mods.length) return;
      var html = '<div class="ptc-group"><h3>' + g.label + '</h3>';
      mods.forEach(function(m){
        var vs = availVariants(m);
        var img = m.image ? '<img class="ptc-thumb" src="' + m.image + '" alt="">' : '<span class="ptc-thumb"></span>';
        if(vs.length === 1){
          html += '<div class="ptc-opt" data-pid="' + m.productId + '" data-single="1" data-vid="' + vs[0].id + '" data-price="' + vs[0].price + '">'
                + '<input type="checkbox" tabindex="-1">' + img
                + '<span class="ptc-name">' + esc(m.title) + '</span>'
                + '<span class="ptc-optprice">' + money(vs[0].price) + '</span></div>';
        } else {
          var opts = '<option value="">Choose option…</option>';
          vs.forEach(function(v){ opts += '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + ' — ' + money(v.price) + '</option>'; });
          html += '<div class="ptc-opt ptc-opt--multi" data-pid="' + m.productId + '">'
                + img
                + '<span class="ptc-name" data-basetitle="' + esc(m.title) + '">' + esc(m.title) + '<small>from ' + money(minPrice(m)) + ' · choose an option</small></span>'
                + '<select class="ptc-msel" aria-label="Choose option">' + opts + '</select></div>';
        }
      });
      wrap.insertAdjacentHTML('beforeend', html + '</div>');
    });

    wrap.querySelectorAll('.ptc-opt[data-single="1"]').forEach(function(row){
      row.addEventListener('click', function(){
        var pid = row.getAttribute('data-pid');
        if(selected[pid]){ delete selected[pid]; row.classList.remove('sel'); row.querySelector('input').checked = false; }
        else { selected[pid] = { variantId:+row.getAttribute('data-vid'), price:+row.getAttribute('data-price'), name: row.querySelector('.ptc-name').textContent }; row.classList.add('sel'); row.querySelector('input').checked = true; }
        render_summary();
      });
    });

    wrap.querySelectorAll('.ptc-opt--multi').forEach(function(row){
      var sel = row.querySelector('.ptc-msel');
      sel.addEventListener('change', function(){
        var pid = row.getAttribute('data-pid');
        var base = row.querySelector('.ptc-name').getAttribute('data-basetitle');
        var opt = sel.options[sel.selectedIndex];
        if(sel.value){
          var optLabel = opt.textContent.split(' — ')[0];
          selected[pid] = { variantId:+sel.value, price:+opt.getAttribute('data-price'), name: base + ' (' + optLabel + ')' };
          row.classList.add('sel');
        } else { delete selected[pid]; row.classList.remove('sel'); }
        render_summary();
      });
    });
  }

  // ---------- render summary ----------
  function render_summary(){
    document.getElementById('ptc-turbo-title').textContent = DATA.turbo.title;
    document.getElementById('ptc-turbo-price').textContent = money(turboPrice);
    var mods = Object.keys(selected).map(function(k){ return selected[k]; });
    var subtotal = turboPrice, points = 0, lines = '';
    mods.forEach(function(m){
      subtotal += m.price; points += modPoints(m.price);
      lines += '<div class="ptc-line"><span>' + esc(m.name) + '</span><b>' + money(m.price) + '</b></div>';
    });
    document.getElementById('ptc-mod-lines').innerHTML = lines;
    document.getElementById('ptc-subtotal').textContent = money(subtotal);

    var capped = Math.min(points, 3);
    var pct = capped >= 3 ? 15 : capped === 2 ? 10 : capped === 1 ? 5 : 0;
    modal.querySelectorAll('.ptc-meter i').forEach(function(p,i){ p.classList.toggle('on', i < capped); });
    document.getElementById('ptc-pts').textContent = capped + ' point' + (capped === 1 ? '' : 's');
    document.getElementById('ptc-pct').textContent = pct + '% off';

    var base = Math.max(0, subtotal - turboDeposit);   // refundable core deposit is never discounted
    var disc = Math.round(base * pct / 100);
    var dRow = document.getElementById('ptc-discount');
    if(pct > 0){ dRow.classList.remove('zero');
      document.getElementById('ptc-dmsg').textContent = 'Bundle discount (' + pct + '%)' + (turboDeposit > 0 ? ' · excl. core deposit' : '');
      document.getElementById('ptc-damt').textContent = '–' + money(disc);
    } else { dRow.classList.add('zero');
      document.getElementById('ptc-dmsg').textContent = mods.length ? 'Add a $400+ mod to save' : 'Add a qualifying mod to save';
      document.getElementById('ptc-damt').textContent = '–$0.00';
    }
    document.getElementById('ptc-strike').textContent = pct > 0 ? money(subtotal) : '';
    document.getElementById('ptc-grand').textContent = money(subtotal - disc);

    var add = document.getElementById('ptc-add');
    add.disabled = mods.length === 0;
    add.textContent = mods.length ? ('Add ' + mods.length + ' mod' + (mods.length>1?'s':'') + ' to cart') : 'Add to cart';
  }

  // ---------- open / close ----------
  function openPopup(){
    if(!rendered){ render_groups(); rendered = true; }
    render_summary();
    modal.hidden = false; modal.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function closePopup(){ modal.hidden = true; modal.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; }
  modal.querySelectorAll('[data-ptc-close]').forEach(function(x){ x.addEventListener('click', closePopup); });
  document.getElementById('ptc-skip').addEventListener('click', closePopup);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !modal.hidden) closePopup(); });

  // ---------- add selected mods ----------
  document.getElementById('ptc-add').addEventListener('click', function(){
    var mods = Object.keys(selected).map(function(k){ return selected[k]; });
    if(!mods.length) return;
    var btn = this, old = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: mods.map(function(m){ return { id:m.variantId, quantity:1 }; }) })
    }).then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j && j.description || 'add failed'); }); return r.json(); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(err){ btn.disabled = false; btn.textContent = old; alert('Sorry — could not add those to your cart. ' + (err && err.message ? err.message : 'Please try again.')); });
  });

  // ---------- detection: watch the cart for THIS turbo being added ----------
  // Lightweight: no continuous polling. We only check the cart AFTER an add-to-cart
  // attempt (a few times with backoff, then stop), so we never hammer /cart.js.
  var lastQty = 0, primed = false, watching = false;
  getCart().then(function(c){ if(c){ lastQty = turboQty(c); } primed = true; });

  function check(){
    return getCart().then(function(c){
      if(!c) return;
      if(!primed){ lastQty = turboQty(c); primed = true; return; }
      var q = turboQty(c);
      if(q > lastQty){
        lastQty = q;
        var up = turboUnitPrice(c); if(up) turboPrice = up;
        turboDeposit = turboDepositCents(c);
        if(modal.hidden) openPopup(); else render_summary();
      } else if(q < lastQty){ lastQty = q; }
    });
  }
  function watchForAdd(){
    if(watching) return; watching = true;
    [600, 1300, 2200, 3400, 5000].forEach(function(d){ setTimeout(check, d); });
    setTimeout(function(){ watching = false; }, 5200);
  }
  // Trigger on the real add-to-cart: a click on the ATC button, or a cart-form submit.
  // We never block or intercept it — the theme adds the turbo normally.
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('button[name="add"], .product-form__submit, [data-add-to-cart]') : null;
    if(b && (b.getAttribute('name') === 'add' || (b.closest && b.closest('form[action*="/cart/add"]')))) watchForAdd();
  }, true);
  document.addEventListener('submit', function(e){
    if(e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) watchForAdd();
  }, true);
})();
